import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getKundtabelBokamoteByAfid,setofUpdatedashboardBokaTV } from 'actions'
import {isEmpty} from 'lodash'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Skeleton from '@material-ui/lab/Skeleton';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY} = accountsData
    const { BokningTable,DashboardBokaFilterOption} = DashBoard;
    return {
        authUser,BokningTable,DashboardBokaFilterOption,updatedashboardBokaTY

    };
}
function mapDispatchToProps(dispatch) {
    return {
        getKundtabelBokamoteByAfid: (Afid,userid,FilterOption) => dispatch(getKundtabelBokamoteByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    }
}
const useStyles = theme => ({
    root: {
        '&::-webkit-scrollbar': {
            width: '5px'
          },
           
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
           
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
          }
     },
});

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#12585E',
        // backgroundColor: '#14484D',
      },
    },
}))(TableRow);
class CustomizedTables extends Component {
    state={
        BokningTable:[],
        DashboardBokaFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getKundtabelBokamoteByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })         
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getKundtabelBokamoteByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            this.props.getKundtabelBokamoteByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
            this.props.setofUpdatedashboardBokaTV()
        }
        if(this.props.DashboardBokaFilterOption !== this.state.DashboardBokaFilterOption && !isEmpty(this.props.DashboardBokaFilterOption))
           {
                
            this.setState({ done:false })
               this.props.getKundtabelBokamoteByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
               this.setState({
                DashboardBokaFilterOption:this.props.DashboardBokaFilterOption 
               }) 
           }
       }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root} style={{ width: '95%',overflowY: "auto",height: this.props.height }}>
                  {
          this.state.done === false?
          <div style={{display: "flex",flexFlow: "column",width: "95%"}}>
          <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
          <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
          <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
          <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
          </div>
          :
            <Table>
                <TableBody>
                    {
                    isEmpty(this.props.BokningTable)?"":
                    this.props.BokningTable.map(n => {
                        return (
                            <StyledTableRow key={n.id}>
                                <TableCell align="left" style={{ paddingTop: '5px', paddingBottom: '5px', color: 'white', borderBottom: '1px solid transparent'  }}>
                                    {
                                        n.customer.length > 20 ?
                                        <>{n.customer.slice(0,20)}...</>
                                        : 
                                        n.customer
                                    }
                                </TableCell>
                                <TableCell align="right" style={{ paddingTop: '5px', paddingBottom: '5px', color: 'white', borderBottom: '1px solid transparent', whiteSpace: 'nowrap'  }}>
                                    {n.date}
                                </TableCell>
                            </StyledTableRow>
                        );
                    })}
                </TableBody>
            </Table>
            }
        </div>
        ) 
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
  )(withStyles(useStyles)(CustomizedTables));